import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const init = (isRM) => {
  if (isRM) return;
  const mm = gsap.matchMedia();
  mm.add(
    {
      isDesktop: '(min-width: 767px)',
      isMobile: '(max-width: 766px)'
    },
    (context) => {
      const { isDesktop, isMobile } = context.conditions;
      const items = document.querySelectorAll('[data-stat-item]');

      if (isMobile) {
        ScrollTrigger.batch(items, {
          start: 'top bottom-=10%',
          onEnter: (batch) =>
            gsap.fromTo(
              batch,
              { opacity: 0, y: 35 },
              { opacity: 1, y: 0, duration: 0.65 }
            ),
          once: true
        });
      }

      if (isDesktop) {
        items.forEach((el, i) => {
          const numEls = el.querySelectorAll('[data-stat-num]');

          numEls.forEach((numEl) => {
            let numArr = [];
            for (let n = 0; n < 7; n++) {
              numArr.push(Math.random() > 0.5 ? 1 : 0);
            }
            numEl.innerText = numArr.join('');
          });

          const fromDir = i % 2 === 0 ? 1 : -1;
          const toDir = i % 2 === 0 ? -1 : 1;

          gsap.fromTo(
            el,
            {
              xPercent: 50 * fromDir,
              // wish I knew why this is the magic number here, but it works on most screens :-/
              '--bg-pos-x': `${-43.333 * toDir}%`
            },
            {
              xPercent: 50 * toDir,
              '--bg-pos-x': `${-43.333 * fromDir}%`,
              ease: 'none',

              scrollTrigger: {
                trigger: el,
                start: 'top bottom+=10%',
                end: 'bottom top',
                scrub: 3
              }
            }
          );
        });
      }
    }
  );
};

export { init };
